// Shared rule for the network status pair (FR-040; data-model §12).
type Reachability = {
  isConnected: boolean | null;
  isInternetReachable: boolean | null;
};

/** Offline only on a definite `false`; unknown (`null`) counts as online, so uncertainty shows no banner. */
export function isOnline(state: Reachability): boolean {
  return !(state.isConnected === false || state.isInternetReachable === false);
}
